import "../css/style.scss"
// For translation use the __(string, domain) function
//const __ = wp.i18n.__
import $ from "jquery";
import Slider from "./modules/Slider.js";

/*
import ABtest from "./modules/ABtest.js";
const abtest = new ABtest();
*/

import TimeNotifications from "./modules/Openingtimes.js";
const timeNotifications = new TimeNotifications();
timeNotifications.setPickupNotificationText('#instock-notification');
timeNotifications.setPickupNotificationText('.contact__link-text.telephone');
timeNotifications.setPickupNotificationText('.contact__link-text.whatsapp');
let qtyInput = $('input.qty');


function toggleOverlay(action, important=false){

    let overlay = $('.site-overlay:not(.mobile)');

    if (action == 'off'){
        overlay.removeClass('active');
        if (important){
            overlay.removeClass('active-important');
        }
    }
    else{
        overlay.addClass('active');
        if (important){
            overlay.addClass('active-important');
        }
    }	
}



function initGeneral(){
    $('.btn-go-back').on('click', function(e){
        e.preventDefault();
        window.history.back();
    }); 

    // The last item in the breadcrumb is a link back
    $('.rank-math-breadcrumb span.last').on('click', function(){
        window.history.back();
    });

    // When clicking on nav item stop propagation so that the overlay doesn't dissapear
    $('.site-header__main-navigation').on('click', function(e){
        e.stopPropagation();
    });
    
}


function initMenuOverlay(){
    let menuItem = $('.category-menu .big-menu.has-sub, .main-nav__all');
    
    menuItem.each(function(){

        $(this).on('mouseenter', () => {
            if (!$('.site-overlay').hasClass('active')){
                toggleOverlay('on');
            }
        });
        $(this).on('mouseleave', () => {
            if ($('.site-overlay').hasClass('active')){
                toggleOverlay('off');
            }
        });
    })
}


function initTaxChange() {
    let taxSwitch = $('.tax-switch');
    let taxExcl;

    if ($('body.woocommerce-checkout').length > 0 || $('body.woocommerce-cart').length > 0){
        return;
    }

    taxSwitch.find('input').on('click', function(){     
        if (taxSwitch.hasClass('active')){
            taxSwitch.find('.tax-switch-text').text('Incl. BTW');
            taxSwitch.removeClass('active');
            $('.exc-btw').addClass('hide');
            $('.inc-btw').removeClass('hide');
            taxExcl = false;
            
        }
        else{
            taxSwitch.find('.tax-switch-text').text('Excl. BTW');
            taxSwitch.addClass('active');
            $('.inc-btw').addClass('hide');
            $('.exc-btw').removeClass('hide'); 
            taxExcl = true;
        }
        
        
        if (qtyInput.length > 0){
            qtyInput.trigger('change'); 
        }    
        
        // Make an AJAX request to set the global variable
        $.ajax({
            url: wemake.ajax_url, // WordPress AJAX endpoint
            type: 'POST',
            data: {
                action: 'set_global_variable', 
                value: taxExcl
            },
            error: function(error) {
                console.error('Error setting global variable for tax:', error);
            }
        });
        
    });
}

function initShoppingCartPopup (){
    let shoppingCartPopup = $('#shopping-cart');


    $('.cart-header').on('click', function(e){   
        closeAllPopups();  
        e.stopPropagation();  
        if (shoppingCartPopup.hasClass('active')){
            shoppingCartPopup.removeClass('active');
            toggleOverlay('off', true);
        }
        else{
            shoppingCartPopup.addClass('active');
            toggleOverlay('on', true);
        }
    });

    shoppingCartPopup.on('click', function(e){
        e.stopPropagation();
    });
}


function initLoginPopup (){
    let loginPopup = $('.login_popup_wrapper');

    $('.login-popup-btn').on('click', function(e){
        closeAllPopups();
        e.stopPropagation();
        e.preventDefault();
        if (loginPopup.hasClass('active')){
            loginPopup.removeClass('active');
            toggleOverlay('off', true);
        }
        else{
            loginPopup.addClass('active');
            toggleOverlay('on', true);
        }
    });

    loginPopup.on('click', function(e){
        e.stopPropagation();
    });

    $(window).on('click', function(e){

        // Don't close popup for the reset button berocket
        if (!$(e.target).is($('.bapf_reset'))){
            closeAllPopups();
        }   
    });
} 

function closeAllPopups (){
    $('.login_popup_wrapper').removeClass('active');
    $('#shopping-cart').removeClass('active');
    $('.nav-menu-popup').removeClass('active');
    toggleOverlay('off', true);
    toggleOverlayMobile('off',true);
}


function initTogglePasswordVisibility() {
    $('.password-toggle').on('click', function(){
        let password = $(this).parent().find('#user_pass');

        if (password.attr('type') === 'password') {
            password.attr('type', 'text');
            $(this).text('Verberg');
        } else {
            password.attr('type', 'password');
            $(this).text('Toon');
        }
    });
}


function initRankMath(){
    let faqItem = $('.rank-math-list-item');

    faqItem.each(function() {
        let answer = $(this).find('.rank-math-answer');

        $(this).attr('data-height', answer.height());
        answer.css('height', 0);

        $(this).find('.rank-math-question').on('click', function(){
            let height = $(this).parent().attr('data-height');
            
            
            if ($(this).parent().hasClass('active')){
                answer.css('height', 0);
                $(this).parent().toggleClass('active');
            }
            else {
                answer.css('height', height);
                $(this).parent().toggleClass('active');
            }
            
        });
    });
}

function initHeaderFixed(){
    if ($('#wpadminbar').length > 0){
        $('.usp-header').addClass('admin-bar');
        $('.site-header__fixed').addClass('admin-bar');
    }

    // If scroll more than 136 pixels give the site-header a class fixed
    $(window).on('scroll', function(){
        if ($(this).scrollTop() > 40){
            $('.site-header__fixed').addClass('fixed');
        }
        else{
            $('.site-header__fixed').removeClass('fixed');
        }
    });
}


function initFooterMenu(){
    let footerMenu = $('.footer .mobile-header');

    footerMenu.each(function(){
        let link = $(this);

        link.on('click', function(){
            let menu = link.parent().find('.menu');
            if (menu.parent().parent().hasClass('active')){
                menu.parent().parent().removeClass('active');
            }
            else{
                menu.parent().parent().addClass('active');
            }
        });
    });
}

function initDescriptionSwitch(){
    let description = $('.description-switch');

    description.find('.full-text-btn').on('click', function(){
        let currentDesc = $(this);

        currentDesc.toggleClass('active');
        currentDesc.parent().find('.full-text').toggleClass('hidden-small');
        currentDesc.parent().find('.excerpt').toggleClass('hidden-small');

        if (currentDesc.hasClass('active')){
            currentDesc.text('Minder lezen');
        }
        else{
            currentDesc.text('Verder lezen');
        }
    });
}

function toggleOverlayMobile(action, important=false){
    let overlay = $('.site-overlay.mobile');

    if (action == 'off'){
        overlay.removeClass('active');
        if (important){
            overlay.removeClass('active-important');
        }
    }
    else{
        overlay.addClass('active');
        if (important){
            overlay.addClass('active-important');
        }
    }	
}

function initMobilePopup(popupClass, buttonClass){
    let popup = $(popupClass);

    $(buttonClass).on('click', function(e){
       popup.addClass('active'); 
       e.preventDefault();
       e.stopPropagation();
       toggleOverlayMobile('on');
    });

    popup.find('.close').on('click', function(e){
       popup.removeClass('active');
       e.stopPropagation();
       toggleOverlayMobile('off');
    });

    popup.on('click', function(e){
        // Don't stop propagation for the reset button by berocket
        if (!$(e.target).is($('.bapf_reset'))){
            e.stopPropagation();
        }    
    });
}

function initMobileNavMenu (){
    let menu = $('.standard-menu-mobile');
    let allBigItems = menu.find('.big-menu');
    let allCats = $('.nav-menu-popup__all-cats');
    let currentLink;
    let navMenuHeaderSearch = $('.nav-menu-popup__header-search');
    let navMenuHeader = $('.nav-menu-popup__header');

    menu.find('.big-menu.has-sub > a').each(function(){
        $(this).on('click', function(e){
            e.preventDefault();
            navMenuHeaderSearch.addClass("hide");
            navMenuHeader.removeClass("hide");
            allBigItems.addClass('hide');
            allCats.addClass('active');
            currentLink = $(this);
            currentLink.parent().removeClass('hide');
            currentLink.parent().addClass('active');
            currentLink.off('click');
        });
    });

    allCats.on('click', function(){
        navMenuHeaderSearch.removeClass("hide");
        navMenuHeader.addClass("hide");
        allBigItems.removeClass('hide');
        allBigItems.removeClass('active');
        allCats.removeClass('active');


        currentLink.on('click', function(e){
            e.preventDefault();
            navMenuHeaderSearch.addClass("hide");
            navMenuHeader.removeClass("hide");
            allCats.addClass('active');
            allBigItems.addClass('hide');
            currentLink.parent().removeClass('hide');
            currentLink.parent().addClass('active');
            currentLink.off('click');
        });
    });  
}


function initNotificationBar(){
    const d = new Date();
    let day = d.getDay();

    let notificationBar = $('.notification-bar');
    if (notificationBar.length > 0){
        let message = notificationBar.data('text');
        let dateParts = notificationBar.data('start').split('/');
        let start = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        dateParts = notificationBar.data('end').split('/');
        let end = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);

        if (message != '' && d.getTime() >= start.getTime() && d.getTime() <= end.getTime()){
            notificationBar.find('.container').append('<span>' + message + '</span>');
        }
    }
}


// Document ready
$(function(){

let viewportWidth = $(window).width();
    
    typeof initHeaderFixed != "undefined" ? initHeaderFixed() : "";
    typeof initMenuOverlay != "undefined" ? initMenuOverlay() : "";
    typeof initTaxChange != "undefined" ? initTaxChange() : "";
    typeof initShoppingCartPopup != "undefined" ? initShoppingCartPopup() : "";
    typeof initGeneral != "undefined" ? initGeneral() : "";
    typeof initLoginPopup != "undefined" ? initLoginPopup() : "";
    typeof initTogglePasswordVisibility != "undefined" ? initTogglePasswordVisibility() : "";
    typeof initRankMath != "undefined" ? initRankMath() : "";
    typeof initFooterMenu != "undefined" ? initFooterMenu() : "";
    typeof initDescriptionSwitch != "undefined" ? initDescriptionSwitch() : "";
    typeof initNotificationBar != "undefined" ? initNotificationBar() : "";
    

if (viewportWidth < 1024){
    typeof initMobileNavMenu != "undefined" ? initMobileNavMenu() : "";

    initMobilePopup('.nav-menu-cat', '.mobile-menu-btn');
    initMobilePopup('.login-menu', '.login-btn');
    initMobilePopup('.description-popup', '.description-btn');
    initMobilePopup('.specifications-popup', '.specifications-btn');
    initMobilePopup('.product-variations-popup', '.product-variations-btn');
    initMobilePopup('.product-filters-popup', '.product-filters-btn');
}

});